import { Stack } from '@chakra-ui/react'
import { AboutUsHero } from './hero'
import { PartnerOverview } from './partner-overview/partner-overview'
import { TeamOverview } from './team-overview/team-overview'

export const AboutUs = () => (
  <Stack w="full" pt={[24, 24, 24]} h="full" bgColor="txtBlack">
    <AboutUsHero />
    <TeamOverview />
    <PartnerOverview />
  </Stack>
)
